import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "@/pages/Landing";
import StoryPage from "@/pages/StoryPage";

function App() {
    return (
        <div className="App font-sans">
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<Landing />} />
                    <Route path="/story" element={<StoryPage />} />
                </Routes>
            </BrowserRouter>
        </div>
    );
}

export default App;
